import React from "react";
import { Download } from "react-feather";
import { Row, Col } from "reactstrap";

const ImportStep1Header = () => {
  return (
    <Row className="align-items-md-end align-items-start justify-content-between mb-3">
      <Col md={9} xs={12}>
        <div className="d-flex align-items-center gap-2 mb-2">
          <div
            style={{
              width: "20px",
              height: "20px",
              backgroundColor: "#697277",
              color: "white",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: 500,
              fontFamily: "Roboto",
            }}
          >
            1
          </div>
          <div
            style={{
              fontSize: "20px",
              fontWeight: 500,
              color: "#697277",
            }}
          >
            Upload your file
          </div>
        </div>
        <div
          style={{
            fontSize: "16px",
            color: "#A5A1A1",
          }}
        >
          Select a file containing your contacts to import.
        </div>
      </Col>

      <Col
        md="auto"
        className="d-flex justify-content-center align-items-center"
      >
        <a
          href="https://drive.google.com/uc?export=download&id=1a3e_izI_UyF7W1_dNGDHfI1L9XmeEmiw"
          target="_blank"
          rel="noopener noreferrer"
          download="demo-csv.csv"
          className="d-flex align-items-center gap-1 text-dark"
          style={{
            fontSize: "15px",
            textDecoration: "none",
          }}
        >
          <Download size={16} /> Download example file (.csv)
        </a>
      </Col>
    </Row>
  );
};

export default ImportStep1Header;
